import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { routes } from "routes";
import NotFound from "views/errors/404";

export default function Auth() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`${prop.path}`} element={prop.component} key={key} />
        );
      }
      if (prop.collapse) {
        return getRoutes(prop.items);
      }
      return null;
    });
  };
  document.documentElement.dir = "ltr";
  return (
    <div className="min-h-screen w-full bg-canvas text-fg">
      <main className="mx-auto min-h-screen">
        <Routes>
          {getRoutes(routes)}
          <Route path="/" element={<Navigate to="/auth/signin" replace />} />
          <Route path="*" element={<NotFound showLogo />} />
        </Routes>
      </main>
    </div>
  );
}
